import React from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import News1 from "../media/news-1.jpeg";
import News2 from "../media/news-2.jpeg";
import News3 from "../media/news-3.jpeg";
import News4 from "../media/news-4.jpeg";
import { BiTimeFive } from "react-icons/bi";

function News() {
  const myMonth = new Date().getMonth();
  const myDate = new Date().getDate();
  const myYear = new Date().getFullYear();

  const fullDate = `${myMonth}.${myDate}.${myYear}`;

  return (
    <div>
      <div className="md:container md:mx-auto flex flex-col items-center">
        <h1 className="sm:ml-16 md:ml-0 sm:self-start  md:self-center mt-16 uppercase font-extrabold text-2xl inline-block border-b border-second">
          xəbərlər
        </h1>
        <div className="cards flex md:flex-nowrap sm:flex-wrap md:gap-x-4 my-16 md:gap-y-0 sm:gap-y-16 sm:justify-center">
          <div className="card md:mx-0 sm:mx-16  flex flex-col gap-y-3 shadow-2xl">
            <img src={News1} alt="" />
            <p className="mx-5 flex gap-x-1 items-center">
              <BiTimeFive />
              {fullDate}
            </p>
            <hr />
            <h1 className="mx-5 text-md font-bold">
              Lorem ipsum dolor sit amet.
            </h1>
            <p className="mx-5">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo,
              doloremque.
            </p>
            <button className="mx-5 font-semibold mb-5 flex text-second ">
              Davamı
              <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
            </button>
          </div>

          <div className="card md:mx-0 sm:mx-16   flex flex-col gap-y-3 shadow-2xl">
            <img src={News2} alt="" />
            <p className="mx-5 flex gap-x-1 items-center">
              <BiTimeFive />
              {fullDate}
            </p>
            <hr />
            <h1 className="mx-5 text-md font-bold">
              Lorem ipsum dolor sit amet.
            </h1>
            <p className="mx-5">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo,
              doloremque.
            </p>
            <button className="mx-5 font-semibold mb-5 flex text-second ">
              Davamı
              <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
            </button>
          </div>

          <div className="card  md:mx-0 sm:mx-16  flex flex-col gap-y-3 shadow-2xl">
            <img src={News3} alt="" />
            <p className="mx-5 flex gap-x-1 items-center">
              <BiTimeFive />
              {fullDate}
            </p>
            <hr />
            <h1 className="mx-5 text-md font-bold">
              Lorem ipsum dolor sit amet.
            </h1>
            <p className="mx-5">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo,
              doloremque.
            </p>
            <button className="mx-5 font-semibold mb-5 flex text-second ">
              Davamı
              <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
            </button>
          </div>

          <div className="card  md:mx-0 sm:mx-16  flex flex-col gap-y-3 shadow-2xl">
            <img src={News4} alt="" />
            <p className="mx-5 flex gap-x-1 items-center">
              <BiTimeFive />
              {fullDate}
            </p>
            <hr />
            <h1 className="mx-5 text-md font-bold">
              Lorem ipsum dolor sit amet.
            </h1>
            <p className="mx-5">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo,
              doloremque.
            </p>
            <button className="mx-5 font-semibold mb-5 flex text-second ">
              Davamı
              <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
            </button>
          </div>
        </div>
        <button className="mb-16 flex justify-center rounded-md md:w-40 sm:w-32 text-white bg-first px-7 py-3">
          Hamısı
          <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
        </button>
      </div>
    </div>
  );
}

export default News;
